import { ContentSection } from '@bw/apis/contentful';

export type ImagePosition = NonNullable<
	ContentSection<undefined>['fields']['imagePosition']
>;

type ColorMap = {
	[key in ImagePosition]: string;
};

export const imagePositionToClassMap: ColorMap = {
	'Fill (left)': 'fillLeft',
	'Fill (right)': 'fillRight',
	'Fit (left)': 'fitLeft',
	'Fit (right)': 'fitRight',
	'Background (right)': 'backgroundRight',
};
